import type { OrganisationDetailed, UpdateOrganisationRequest } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function updateOrganisationDetails(
  organisationId: string,
  formData: UpdateOrganisationRequest
): Promise<OrganisationDetailed> {
  return requestApiJsonOrThrow<OrganisationDetailed>(`admin/organisations/${organisationId}`, {
    method: 'PATCH',
    body: formData,
  })
}
